<template>
  <div class="box-message p-absolute">
    {{ message }}
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    message: {
      type: String,
      default: () => ''
    }
  }
})
</script>

<style lang="scss" scoped>
  .box-message {
    --color: rgb(var(--black));
    --backgroundColor: rgb(var(--white));

    width: max-content;
    max-width: 200px;
    padding: 7px;
    font-size: 12px;
    color: var(--color);
    background-color: var(--backgroundColor);
    left: 30px;
    border-radius: 4px;
    z-index: 2;

    &:after {
      content: '';
      width: 7px;
      height: 7px;
      position: absolute;
      left: -2px;
      top: 5px;
      transform: rotate(45deg);
      background-color: var(--backgroundColor);
    }

    .is-dark-theme & {
      --color: rgb(var(--gray6));
      --backgroundColor: rgb(var(--gray8));
    }
  }
</style>
